import type { Optional } from '@festina-life/core'

/**
 * Yup uses its internal prepareDataForValidation function to transform inputs with empty strings to undefined.
 * This function reverses that transformation.
 * @param path
 */
export const safeValidationPath = (
  path: Optional<string>[] | undefined,
): string[] => (path ?? []).map((part) => part ?? '')
